module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/martech_bg_1-0f908a5ac8dac2543fc49e40357da877.png";